import { render, staticRenderFns } from "./WidgetBuilder.vue?vue&type=template&id=2d67c246&"
import script from "./WidgetBuilder.vue?vue&type=script&lang=js&"
export * from "./WidgetBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports